export default __webpack_public_path__ + "static/media/1.4ab0fc17.jpg";